import Numeral from 'numeral';
import Cache from 'root/cache';
import View from 'view/base';
import Util from 'root/module/util';

export default View.extend({
    initialize: function(options) {
        this.data = options.data;
    },

    render: function() {
        var feedback_total = this.data.feedback_total;
        var overdue_feedback = this.data.feedback_overdue;
        var workflow_options = '';
        var project_key = Cache.getDefaultProject().get('project_key');

        if (overdue_feedback.total) {
            var overdue_percent = feedback_total === 0 ? 0 : (overdue_feedback.total / feedback_total * 100);
            var feedback_due_date = overdue_feedback.date ? Util.moment(overdue_feedback.date, 'YYYY-MM-DD', false, false) : '';

            var workflows = Cache.workflow.where({project_id: Cache.default_project_id})
            var workflow_ids_exclude_resolved = workflows.slice(0, -1).map(workflow_model => workflow_model.id);

            workflow_options += '<a href="/' + project_key + '/feedback/?due_date=|' + feedback_due_date + '&workflow=' + workflow_ids_exclude_resolved.join(',') + '" class="grid-6-6 feedback-status-row overflow-hidden navigation text-danger">' +
                '<div class="font-weight-medium">' +
                    '<i class="fa-regular fa-calendar-circle-exclamation tooltip margin-right-4" data-title="Over Due"></i>Overdue' +
                '</div>' +
                '<div>' +
                    '<span class="total">' + Numeral(overdue_feedback.total).format('0,0') + '</span>' +
                    '<span class="bar bar-danger" style="width:' + (overdue_percent * 0.8) + 'px;"></span>' +
                    '<span class="info text-danger">' + overdue_percent.toFixed(2) + '%</span>' +
                '</div>' +
            '</a>';
        }

        Cache.workflow.where({project_id: Cache.default_project_id}).forEach((workflow_model) => {
            var feedback_count = this.data.feedback_workflow[workflow_model.id] ? this.data.feedback_workflow[workflow_model.id].total : 0;
            var feedback_percent = feedback_total === 0 ? 0 : (feedback_count / feedback_total * 100);

            workflow_options +=
            '<a href="/' + project_key + '/feedback/?workflow=' + workflow_model.id + '" class="grid-6-6 feedback-status-row overflow-hidden navigation">' +
                '<div class="font-weight-medium">' + workflow_model.escape('name') + '</div>' +
                '<div>' +
                    '<span class="total">' + Numeral(feedback_count).format('0,0') + '</span>' +
                    '<span class="bar" style="width:' + (feedback_percent * 0.8) + 'px;"></span>' +
                    '<span class="info">' + feedback_percent.toFixed(2) + '%</span>' +
                '</div>' +
            '</a>';
        });

        // render at least 4 rows
        if (Cache.workflow.length < 4) {
            for (var i = 0; i < 4 - Cache.workflow.length; i++) {
                workflow_options += '<div class="feedback-status-row overflow-hidden">&nbsp;</div>';
            }
        }

        var content =
        '<div class="box box-nopadding">' +
            '<div>' + workflow_options + '</div>' +
        '</div>';

        this.$el.html(content);

        return this;
    }
});